import {Pipe, PipeTransform} from '@angular/core';
import {Ttm} from '../classes/ttm';
import {TtmStatus} from '../classes/ttmstatus';

@Pipe({
    name: 'marker'
})
export class MarkerPipe implements PipeTransform {

    transform(ttm: Ttm, trigger: string, overrideStatus: TtmStatus = null, camera = false): HTMLElement {

        const parser = new DOMParser();

        const cameraSvgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 25px; height: 25px;"><path fill="#${(overrideStatus ?? ttm.status)?.color}" d="M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"/></svg>`;

        const pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 25px; height: 25px;"><path fill="#${(overrideStatus ?? ttm.status)?.color}${(overrideStatus ?? ttm.status)?.color_group > 9 ? 'cc' : '66'}" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>`;

        const pinSvg = parser.parseFromString(camera ? cameraSvgString : pinSvgString, 'image/svg+xml').documentElement;

        return pinSvg;
    }

}
